import { useCallback } from 'react'

import { BuilderPage } from '@makyoapp/makyo-common'

import { Accordion } from '@/components/Accordion/Accordion'

import { BehaviorAccordion } from './Accordions'

interface PageSettingBehaviourProps {
  page: BuilderPage
  pageIdx: number
  search: string
}

export const PageSettingBehaviour = ({ page, pageIdx, search }: PageSettingBehaviourProps) => {
  const getFilteredAccordionItems = useCallback(() => {
    if (!search.trim()) {
      return {
        showBehaviorSettings: true,
      }
    }

    const searchLower = search.toLowerCase()

    return {
      showBehaviorSettings: 'behavior'.includes(searchLower) || 'visibility'.includes(searchLower),
    }
  }, [search])

  const filteredItems = getFilteredAccordionItems()

  const isTblPage = !!page.tableId

  return (
    <>
      {filteredItems.showBehaviorSettings && (
        <Accordion openMultiple={false} initialActiveItems={['behavior-settings']}>
          {!isTblPage && page && <BehaviorAccordion page={page} pageIdx={pageIdx} />}
        </Accordion>
      )}
    </>
  )
}
